import * as React from "react";
import { Link } from "react-router-dom";
import { tv } from "tailwind-variants";
import type { VariantProps } from "tailwind-variants";

const buttonVariants = tv({
  base: "focus-visible:ring-ring inline-flex items-center cursor-pointer justify-center whitespace-nowrap rounded-full font-medium text-white ring-gray-900 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2",
  variants: {
    variant: {
      default: "bg-violet hover:bg-violet80",
      error: "bg-red-700 hover:bg-red-500",
      info: "bg-blue-700 hover:bg-blue-500",
      success: "bg-green-700 hover:bg-green-500",
      outline:
        "bg-white border border-violet text-violet hover:bg-violet hover:text-white text-violet",
    },
    size: {
      default: "px-6 py-4 text-base",
      sm: "px-4 py-2 text-sm",
      icon: "h-10 w-10",
    },
    disabled: {
      true: "pointer-events-none bg-gray-500",
    },
  },
  defaultVariants: {
    variant: "default",
    size: "default",
    disabled: false,
  },
});

export type ButtonLinkProps = {
  to: string;
  state?: any;
} & React.ComponentProps<"a"> &
  VariantProps<typeof buttonVariants>;

export const ButtonLink = React.forwardRef<
  React.ElementRef<"a">,
  ButtonLinkProps
>(({ className, variant, size, disabled, to, state, ...props }, ref) => {
  return (
    <Link
      to={to}
      className={buttonVariants({ variant, size, disabled, className })}
      ref={ref}
      state={state}
      {...props}
    />
  );
});
